import { render } from "./yc-dlt.vue?vue&type=template&id=45737e06&scoped=true"
import script from "./yc-dlt.vue?vue&type=script&lang=js"
export * from "./yc-dlt.vue?vue&type=script&lang=js"

import "./yc-dlt.vue?vue&type=style&index=0&id=45737e06&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45737e06"]])

export default __exports__